module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.completedExaminations) ? _c('div', {
    staticClass: "analysis-method__wrapper mb-5"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('ANALYSIS_METHOD')))]), _vm._v(" "), _c('div', {
    staticClass: "analysis-method__info"
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.$t('ACTUAL_ANALYSIS_METHOD')) + ":\n            "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.analysisMethod))])]), _vm._v(" "), (_vm.completedExaminations <= _vm.stepsLength) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.$t('REQUIREMENTS_FOR_COMPARABLE_METHOD', {
    number: _vm.stepsLength + 1 - _vm.completedExaminations
  }))), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('REQUIREMENTS_FOR_COMPARABLE_METHOD_2')) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "analysis-method__status"
  }, [_c('div', {
    staticClass: "status--regular"
  }, [_c('h5', {
    staticClass: "status__title"
  }, [_vm._v(_vm._s(_vm.$t('BASIC_METHOD')))]), _vm._v(" "), _c('div', {
    staticClass: "status__steps"
  }, _vm._l((_vm.stepsLength), function(step) {
    return _c('div', {
      staticClass: "step",
      class: {
        'step--active': step <= _vm.completedExaminations
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "status--comparative"
  }, [_c('h5', {
    staticClass: "status__title"
  }, [_vm._v(_vm._s(_vm.$t('BASIC_AND_COMPARABLE_METHOD')))]), _vm._v(" "), _c('div', {
    staticClass: "status__steps"
  }, [_c('div', {
    staticClass: "step",
    class: {
      'step--active': _vm.completedExaminations > _vm.stepsLength
    }
  })])]), _vm._v(" "), (_vm.completedExaminations <= _vm.stepsLength) ? _c('div', {
    staticClass: "status__info box-shadow"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('REQUIREMENTS_FOR_COMPARABLE_METHOD', {
    number: _vm.stepsLength + 1 - _vm.completedExaminations
  })) + "\n        ")]) : _c('div', {
    staticClass: "status__info"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('COMPARABLE_METHOD_IS_ACTIVE')) + "\n        ")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cc0e21c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/medical-results/analysis-method.vue
// module id = 1197
// module chunks = 0